const security = {
    page_title: 'الأمان',
    title: 'الأمان',
    subtitle: 'قم بتكوين حماية متقدمة ضد الهجمات المتطورة.',
    tabs: {
        captcha: 'CAPTCHA',
        password_policy: 'سياسة كلمة المرور',
        blocklist: 'قائمة الحظر',
        general: 'عام',
    },
    bot_protection: {
        title: 'حماية الروبوت',
        description: 'تفعيل CAPTCHA للتسجيل وتسجيل الدخول واستعادة كلمة المرور لحظر التهديدات الآلية.',
        captcha: {
            title: 'CAPTCHA',
            placeholder: 'اختر مزود CAPTCHA وقم بإعداد التكامل.',
            add: 'إضافة CAPTCHA',
        },
        settings: 'الإعدادات',
        enable_captcha: 'تفعيل CAPTCHA',
        enable_captcha_description: 'تفعيل التحقق CAPTCHA لعمليات التسجيل وتسجيل الدخول واستعادة كلمة المرور.',
    },
    create_captcha: {
        setup_captcha: 'إعداد CAPTCHA',
    },
    captcha_providers: {
        altcha: { name: 'ALTCHA', description: 'حماية مستضافة ذاتيًا باستخدام إثبات العمل.' },
        recaptcha_enterprise: {
            name: 'reCAPTCHA Enterprise',
            description: 'حل CAPTCHA من جوجل للمؤسسات ، الذي يوفر كشفًا متقدمًا عن التهديدات وتحليلات أمنية مفصلة لحماية موقعك من الأنشطة الاحتيالية.',
        },
        turnstile: {
            name: 'Cloudflare Turnstile',
            description: 'بديل CAPTCHA الذكي من Cloudflare الذي يوفر حماية ضد الروبوتات دون إزعاج، مما يضمن تجربة مستخدم سلسة دون ألغاز بصرية.',
        },
        cap: {
            name: 'Cap',
            description: 'CAPTCHA مفتوح المصدر ومستضاف ذاتيًا يعتمد على إثبات العمل دون ألغاز بصرية أو خدمات خارجية، مثالي للمناطق التي يتعذر فيها الوصول إلى خدمات CAPTCHA الأخرى.',
        },
    },
    captcha_details: {
        challenge_url: 'عنوان التحدي',
        verify_url: 'عنوان التحقق',
        verification_key: 'مفتاح التحقق للخادم',
        back_to_security: 'العودة إلى الأمان',
        page_title: 'تفاصيل CAPTCHA',
        check_readme: 'تحقق من README',
        options_change_captcha: 'تغيير مزود CAPTCHA',
        connection: 'الاتصال',
        description: 'تكوين اتصالات captcha الخاصة بك.',
        site_key: 'مفتاح الموقع',
        secret_key: 'المفتاح السري',
        project_id: 'معرف المشروع',
        domain: 'النطاق (اختياري)',
        domain_placeholder: 'www.google.com (افتراضي) أو recaptcha.net',
        recaptcha_key_id: 'معرّف مفتاح reCAPTCHA',
        recaptcha_api_key: 'مفتاح API للمشروع',
        cap_endpoint: 'نقطة نهاية Cap',
        cap_endpoint_placeholder: 'https://cap.example.com',
        cap_endpoint_http_notice: 'تستخدم نقطة النهاية هذه HTTP، وهو مناسب للتطوير المحلي فقط. تحظر المتصفحات طلبات HTTP من صفحة تسجيل دخول تعمل عبر HTTPS، وسيتم إرسال المفتاح السري دون تشفير. استخدم HTTPS في بيئة الإنتاج.',
        deletion_description: 'هل أنت متأكد أنك تريد حذف مزود CAPTCHA هذا؟',
        captcha_deleted: 'تم حذف موفر CAPTCHA بنجاح',
        setup_captcha: 'إعداد CAPTCHA',
        mode: 'وضع التحقق',
        mode_invisible: 'غير مرئي',
        mode_checkbox: 'مربع اختيار',
        mode_notice: 'يتم تحديد وضع التحقق في إعدادات مفتاح reCAPTCHA في Google Cloud Console. يتطلب تغيير الوضع هنا نوع مفتاح مطابق.',
        score_threshold: 'حد النتيجة',
        score_threshold_description: 'يتم رفض النتائج الأقل من الحد الأدنى. 0.0 يسمح بجميع النتائج، 1.0 يسمح فقط بالنتائج المثالية. القيمة الافتراضية هي 0.5.',
        score_threshold_error: 'يجب أن يكون حد النتيجة بين 0 و 1.',
    },
    password_policy: {
        password_requirements: 'متطلبات كلمة المرور',
        password_requirements_description: 'تعزيز متطلبات كلمة المرور للدفاع ضد هجمات ملء بيانات الاعتماد والهجمات باستخدام كلمات المرور الضعيفة.',
        minimum_length: 'الحد الأدنى للطول',
        minimum_length_description: 'يوصي NIST باستخدام <a>على الأقل 8 أحرف</a> للمنتجات على الويب.',
        minimum_length_error: 'يجب أن يكون الحد الأدنى للطول بين {{min}} و {{max}} (شاملاً).',
        minimum_required_char_types: 'الحد الأدنى لأنواع الأحرف المطلوبة',
        minimum_required_char_types_description: 'أنواع الأحرف: الأحرف الكبيرة (A-Z)، الأحرف الصغيرة (a-z)، الأرقام (0-9)، والرموز الخاصة ({{symbols}}).',
        password_rejection: 'رفض كلمة المرور',
        compromised_passwords: 'رفض كلمات المرور المخترقة',
        breached_passwords: 'كلمات المرور المخترقة',
        breached_passwords_description: 'رفض كلمات المرور التي تم العثور عليها سابقًا في قواعد البيانات المخترقة.',
        restricted_phrases: 'تقييد عبارات ضعيفة من الناحية الأمنية',
        restricted_phrases_tooltip: 'يجب تجنب استخدام هذه العبارات في كلمة المرور ما لم تجمعها مع 3 أحرف إضافية أو أكثر.',
        repetitive_or_sequential_characters: 'أحرف متكررة أو متسلسلة',
        repetitive_or_sequential_characters_description: 'مثال: "AAAA"، "1234"، و "abcd".',
        user_information: 'معلومات المستخدم',
        user_information_description: 'مثال: عنوان البريد الإلكتروني، رقم الهاتف، اسم المستخدم، إلخ.',
        custom_words: 'كلمات مخصصة',
        custom_words_description: 'كلمات ذات صلة بالسياق، غير حساسة لحالة الأحرف، وكل كلمة في سطر منفصل.',
        custom_words_placeholder: 'اسم الخدمة الخاص بك، اسم الشركة، إلخ.',
        password_expiration: 'انتهاء صلاحية كلمة المرور',
        password_expiration_description: 'اطلب من المستخدمين إعادة تعيين كلمة المرور الخاصة بهم بعد عدد محدد من الأيام. لا يتأثر المستخدمون الذين يسجلون الدخول عبر SSO أو مفتاح المرور.',
        enable_password_expiration: 'تفعيل انتهاء صلاحية كلمة المرور',
        enable_password_expiration_description: 'اطلب من المستخدمين إعادة تعيين كلمة المرور الخاصة بهم بشكل دوري. سيتم تقييم المستخدمين الحاليين الذين ليس لديهم تاريخ تغيير كلمة مرور مسجل اعتبارًا من تاريخ تفعيل هذه السياسة.',
        enable_password_expiration_tip: 'لا يمكن تفعيل انتهاء صلاحية كلمة المرور إلا بعد إعداد طريقة واحدة على الأقل لاسترجاع كلمة المرور مع موصل صالح في تجربة تسجيل الدخول.',
        expiration_period: 'فترة صلاحية كلمة المرور (أيام)',
        expiration_period_description: 'عدد الأيام التي تظل فيها كلمة المرور صالحة قبل أن تنتهي صلاحيتها.',
        expiration_period_error: 'يجب أن تكون فترة صلاحية كلمة المرور بين {{min}} و{{max}} يومًا.',
        password_expiration_recovery_reminder: 'قد لا يكون لدى بعض المستخدمين عنوان بريد إلكتروني أو رقم هاتف لاستلام رمز استرداد كلمة المرور، لذلك لن يتمكنوا من إعادة تعيين كلمة مرور منتهية الصلاحية. اطلب عنوان بريد إلكتروني أو رقم هاتف عند التسجيل للتأكد من أن كل مستخدم يمكنه استرداد كلمة مروره.',
    },
    verification_code_policy: {
        card_title: 'رمز التحقق',
        card_description: 'قم بتكوين مدة انتهاء الصلاحية والحد الأقصى لمحاولات إعادة المحاولة لرموز التحقق المستخدمة في تدفقات تسجيل الدخول والتسجيل وإعادة تعيين كلمة المرور.',
        enable: {
            title: 'تخصيص إعدادات رمز التحقق',
            description: 'السماح بتخصيص مدة انتهاء صلاحية رمز التحقق والحد الأقصى لمحاولات إعادة المحاولة.',
        },
        expiration_duration: {
            title: 'مدة انتهاء الصلاحية (بالثواني)',
            description: 'المدة بالثواني التي يبقى خلالها رمز التحقق صالحًا بعد إرساله.',
            error_message: 'يجب أن تكون مدة انتهاء الصلاحية بين 60 و 3600 ثانية.',
        },
        max_retry_attempts: {
            title: 'الحد الأقصى لمحاولات إعادة المحاولة',
            description: 'الحد الأقصى لعدد محاولات التحقق الفاشلة المسموح بها قبل إبطال الرمز.',
            error_message: 'يجب أن يكون الحد الأقصى لمحاولات إعادة المحاولة بين 1 و 100.',
        },
    },
    sentinel_policy: {
        card_title: 'قفل الهوية',
        card_description: 'القفل متاح لجميع المستخدمين بالإعدادات الافتراضية، لكن يمكنك تخصيصه لمزيد من التحكم.\n\nاقفل معرفًا مؤقتًا بعد محاولات متعددة فاشلة للتحقق من الهوية (مثل كلمة المرور الخاطئة أو رمز التحقق المتتالي) لمنع الوصول بالقوة العنيفة.',
        enable_sentinel_policy: {
            title: 'تخصيص تجربة القفل',
            description: 'السماح بتخصيص الحد الأقصى لمحاولات تسجيل الدخول الفاشلة قبل القفل، ومدة القفل، والفتح اليدوي الفوري.',
        },
        max_attempts: {
            title: 'الحد الأقصى لمحاولات الفشل',
            description: 'قفل معرف بشكل مؤقت بعد الوصول إلى الحد الأقصى من محاولات تسجيل الدخول الفاشلة خلال ساعة.',
            error_message: 'يجب أن يكون الحد الأقصى لمحاولات الفشل أكبر من 0.',
        },
        lockout_duration: {
            title: 'مدة القفل (بالدقائق)',
            description: 'قفل عمليات تسجيل الدخول لفترة بعد تجاوز الحد الأقصى لمحاولات الفشل.',
            error_message: 'يجب أن تكون مدة القفل دقيقة واحدة على الأقل.',
        },
        manual_unlock: {
            title: 'فتح يدوي',
            description: 'فتح المستخدمين فوراً بتأكيد هويتهم وإدخال هويتهم.',
            unblock_by_identifiers: 'فتح باستخدام الهوية',
            modal_description_1: 'تم قفل الهوية بشكل مؤقت بسبب محاولات تسجيل الدخول/التسجيل الفاشلة المتعددة. لحماية الأمان، سيتم استعادة الوصول تلقائيًا بعد انتهاء مدة القفل.',
            modal_description_2: 'فقط افتح يدوياً إذا كنت قد أكدت هوية المستخدم وتأكدت من عدم وجود محاولات وصول غير مصرح بها.',
            placeholder: 'إدخال الهويات (عنوان البريد الإلكتروني / رقم الهاتف / اسم المستخدم)',
            confirm_button_text: 'افتح الآن',
            success_toast: 'تم الفتح بنجاح',
            duplicate_identifier_error: 'تمت إضافة الهوية بالفعل',
            empty_identifier_error: 'يرجى إدخال معرف واحد على الأقل',
        },
    },
    blocklist: {
        card_title: 'قائمة حظر البريد الإلكتروني',
        card_description: 'تحكم في قاعدة المستخدمين الخاصة بك عن طريق حظر عناوين البريد الإلكتروني عالية الخطورة أو غير المرغوب فيها.',
        custom_email_allowlist: {
            title: 'السماح بعناوين بريد إلكتروني مخصصة',
            description: 'أضف قواعد للسماح فقط بنطاقات بريد إلكتروني أو عناوين بريد إلكتروني أو أنماط أحرف بدل محددة للتسجيلات الجديدة وعناوين البريد الإلكتروني المرتبطة حديثًا. أمثلة: bar@example.com، @example.com، foo*@example.com، *@example.com. يتم التعامل مع النطاقين gmail.com و googlemail.com على أنهما متكافئان، ويتم تجاهل النقاط في الجزء المحلي، لذا يتطابق foo.bar@gmail.com مع foobar@googlemail.com.',
            placeholder: 'أدخل عنوان بريد إلكتروني أو نطاقًا أو نمط أحرف بدل',
            duplicate_error: 'تمت إضافة عنوان البريد الإلكتروني أو النطاق أو نمط عنوان البريد الإلكتروني مسبقًا',
            invalid_format_error: 'يجب أن يكون عنوان بريد إلكتروني صالحًا (bar@example.com)، أو نطاقًا (@example.com)، أو نمط عنوان بريد إلكتروني بأحرف بدل (foo*@example.com، *@example.com)',
            warnings: {
                identical_entries: 'توجد بعض إدخالات قائمة السماح أيضًا في قواعد الحظر. قد تظل رسائل البريد الإلكتروني المطابقة محظورة.',
                blocked_exact_email: 'تطابق بعض عناوين البريد الإلكتروني الدقيقة في قائمة السماح قاعدة حظر. قد تظل رسائل البريد الإلكتروني المطابقة محظورة.',
                blocked_subaddressing: 'تحتوي بعض إدخالات قائمة السماح على علامة الجمع (+)، لكن عنونة البريد الإلكتروني الفرعية محظورة.',
                effectively_unusable: 'استنادًا إلى هذه الفحوصات، قد لا تسمح قائمة السماح الحالية بمرور أي بريد إلكتروني جديد.',
            },
        },
        disposable_email: {
            title: 'حظر عناوين البريد الإلكتروني المؤقتة',
            description: 'تمكين رفض أي محاولات تسجيل باستخدام بريد إلكتروني مؤقت أو مهمل، مما يمكن أن يمنع الرسائل غير المرغوب فيها ويحسن جودة المستخدم.',
        },
        email_subaddressing: {
            title: 'حظر العناوين الفرعية للبريد الإلكتروني',
            description: 'تمكين رفض أي محاولات تسجيل باستخدام العناوين الفرعية للبريد الإلكتروني مع علامة زائد (+) وحروف إضافية (على سبيل المثال، user+alias@foo.com).',
        },
        custom_email_address: {
            title: 'حظر عناوين البريد الإلكتروني المخصصة',
            description: 'أضف قواعد لمنع نطاقات بريد إلكتروني أو عناوين بريد إلكتروني أو أنماط أحرف بدل محددة من التسجيل أو الارتباط عبر واجهة المستخدم. أمثلة: bar@example.com، @example.com، foo*@example.com، *@example.com. يتم التعامل مع النطاقين gmail.com و googlemail.com على أنهما متكافئان، ويتم تجاهل النقاط في الجزء المحلي، لذا يتطابق foo.bar@gmail.com مع foobar@googlemail.com.',
            placeholder: 'أدخل عنوان بريد إلكتروني أو نطاقًا أو نمط أحرف بدل',
            duplicate_error: 'تمت إضافة عنوان البريد الإلكتروني أو النطاق أو نمط عنوان البريد الإلكتروني بأحرف بدل بالفعل',
            invalid_format_error: 'يجب أن يكون عنوان بريد إلكتروني صالحًا (bar@example.com) أو نطاقًا (@example.com) أو نمط عنوان بريد إلكتروني بأحرف بدل (foo*@example.com، *@example.com)',
        },
    },
};
export default Object.freeze(security);
